import $ from 'jquery';
import moment from 'moment';
import { BroadcastChannel } from 'broadcast-channel';

const reinforcedSecurity = {
    $indicator: null,
    $timer: null,
    broadcastChannel: null,
    isRequired: false,
    expiresAt: null,
    updateIndicatorIID: null,

    // Initialize Reinforced Security Indicator
    init: function ($indicator) {
        if (! $indicator.length) {
            return;
        }

        reinforcedSecurity.$indicator = $indicator;
        reinforcedSecurity.$timer = reinforcedSecurity.$indicator.find('.reinforced-security-timer');

        reinforcedSecurity.broadcastChannel = new BroadcastChannel('reinforced_security');
        reinforcedSecurity.broadcastChannel.onmessage = function (msg) {
            reinforcedSecurity.expiresAt = msg.expiresAt !== null ? moment(msg.expiresAt) : null;
            reinforcedSecurity.updateIndicator();
        };

        // "Leave" menu item
        reinforcedSecurity.$indicator.find('.reinforced-security-leave').click(function () {
            reinforcedSecurity.$indicator.children('.btn').addClass('is-pending');

            $.ajax({
                url: '/user/confirm-password/reset',
                method: 'POST',
                dataType: 'json',
            })
                .then(
                    (response) => { reinforcedSecurity.updateFromServer(response.expires_in); },
                    (xhr) => { console.error(xhr); },
                )
                .then(() => { reinforcedSecurity.$indicator.children('.btn').removeClass('is-pending'); });
        });

        // Is reinforced security required on current page?
        reinforcedSecurity.isRequired = Boolean(reinforcedSecurity.$indicator.data('isRequired'));

        // Initialize current state with server-data from current page
        reinforcedSecurity.updateFromServer(reinforcedSecurity.$indicator.data('expiresIn'));
    },

    updateFromServer: function (expiresIn) {
        if (expiresIn === undefined) {
            return;
        }

        reinforcedSecurity.expiresAt = expiresIn > 0 ? moment().add(expiresIn, 'ms') : null;

        reinforcedSecurity.broadcastChannel.postMessage({
            expiresAt: reinforcedSecurity.expiresAt !== null ? reinforcedSecurity.expiresAt.valueOf() : null,
        });

        reinforcedSecurity.updateIndicator();
    },

    updateIndicator: function () {
        let expiresIn = reinforcedSecurity.expiresAt !== null ? reinforcedSecurity.expiresAt.diff(moment()) : 0;

        if (expiresIn > 0) {
            reinforcedSecurity.$timer.text(moment.utc(expiresIn).format('mm:ss'));

            // Indicator is currently hidden => show it
            if (reinforcedSecurity.updateIndicatorIID === null) {
                reinforcedSecurity.$indicator.show();

                reinforcedSecurity.updateIndicatorIID = setInterval(reinforcedSecurity.updateIndicator, 100);
            }

        } else {
            // Current page requires reinforced security, and it has expired => redirect user to homepage
            if (reinforcedSecurity.isRequired) {
                location.replace('/');
            }

            // Indicator is currently shown => hide it
            if (reinforcedSecurity.updateIndicatorIID !== null) {
                reinforcedSecurity.$indicator.hide();

                clearInterval(reinforcedSecurity.updateIndicatorIID);
                reinforcedSecurity.updateIndicatorIID = null;
                reinforcedSecurity.expiresAt = null;
            }
        }
    },
};

$(function () {
    reinforcedSecurity.init($('#reinforced-security-indicator'));
});

export default reinforcedSecurity;
